import { colorsPalettes } from "@similarweb/styles";
import { calcChange } from "app/UtilitiesAndConstants/UtilityFunctions/change";
import get from "lodash/get";
import {
    deviceTitleMap,
    storeTotalTexts,
} from "app/pages/app-intelligence/app-analysis/pages/Engagement/components/Widgets/OvertimeGraph/constants";
import { ENGAGEMENT_TAB_MONTHLY } from "app/pages/app-intelligence/app-analysis/pages/Engagement/constants";
import type { EngagementPoPGraphResponse } from "app/pages/app-intelligence/app-analysis/pages/Engagement/queries/types";
import { EDevice } from "app/pages/app-intelligence/common-components/device-picker/types";
import type { EStores } from "app/pages/app-intelligence/constants";

type POPValue = { Confidence: number; Key: string; Value: number };
type POPChartDataItem = {
    Key: string;
    Value: POPValue | number;
};

const getConfidenceFromValue = (value: POPValue | number): number | undefined =>
    typeof value === "number" ? undefined : value?.Confidence;

export const transformToPopData = (data: POPChartDataItem[], compareData: POPChartDataItem[]) =>
    data.map(({ Value, Key }, index) => {
        const Confidence = getConfidenceFromValue(Value);
        const cValue = get(compareData, [index, "Value"], null);
        const cKey = get(compareData, [index, "Key"], null);
        const comparedConfidence = getConfidenceFromValue(cValue);

        return {
            Values: [
                {
                    Key,
                    Value,
                    Confidence,
                },
                {
                    Key: cKey,
                    Value: cValue,
                    Confidence: comparedConfidence,
                },
            ],
            Change: [
                calcChange(
                    typeof Value === "number" ? Value : Value.Value,
                    typeof cValue === "number" ? cValue : cValue.Value,
                ),
            ],
        };
    });

export const getIntervals = (
    response: EngagementPoPGraphResponse,
    appId: string,
    granularity: string,
    device: string,
    metric: string,
) => {
    const comparedInterval = get(response, ["ComparedInterval", appId, "Overtime", granularity, device, metric]);

    const interval = get(response, ["Interval", appId, "Overtime", granularity, device, metric]);

    return { interval, comparedInterval };
};

//Date must follow ascending order to exclude issues
export const getPOPLegend = (durations: string | string[]) => {
    return [
        {
            name: durations[1],
            color: colorsPalettes.orange[400],
        },
        {
            name: durations[0],
            color: colorsPalettes.blue[400],
        },
    ];
};

export const getDisplayName = (device?: EDevice, store?: EStores): string => {
    if (!device) {
        // if device not provided on the Apps page it means total device is used (Premium+ case)
        return get(storeTotalTexts, [deviceTitleMap[EDevice.ALL_DEVICES], store]);
    }

    const fixedName = device === EDevice.COMBINED ? EDevice.ALL_DEVICES : device;

    if (fixedName === EDevice.ALL_DEVICES) {
        return get(storeTotalTexts, [deviceTitleMap[EDevice.ALL_DEVICES], store]);
    }

    return deviceTitleMap[fixedName] || fixedName;
};

export const MAU_METRICS = [
    "AppEngagementUserActivity",
    ENGAGEMENT_TAB_MONTHLY,
    "AppEngagementMonthlyActiveUsersIos",
    "AppEngagementUserOverview",
    "AppEngagementMonthlyActiveUsers",
];
